import { REGISTER_USER } from '@redux/types';

// REGISTER USER

export const registerUserRequest = payload => ({
  type: REGISTER_USER.START,
  payload
});

export const registerUserInProgress = () => ({
  type: REGISTER_USER.IN_PROGRESS
});

export const registerUserSuccess = payload => ({
  type: REGISTER_USER.SUCCESS,
  payload
});

export const registerUserFailure = () => ({
  type: REGISTER_USER.FAILURE
});
